import { TbTarget } from "react-icons/tb";
import { GetProfileSidebarQueryQuery } from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import { currentOrganizationVar } from "@cache/cache";
import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import GoalStatusPill from "@components/goal-status-pill/goal-status-pill";
import { assertEdgesNonNull } from "@helpers/helpers";

const ProfileSidebarHeader = ({
  data,
}: {
  data: NonNullable<GetProfileSidebarQueryQuery>;
}) => {
  const label = useLabel();
  const organization = currentOrganizationVar();

  const profile = data?.user;
  const ownedGoals = (
    data?.user?.ownedGoals ? assertEdgesNonNull(data.user.ownedGoals) : []
  ).filter((goal) => goal.__typename === "GoalArtifactNode");
  const maxGoalsToShow = 5;

  if (!profile) {
    return null;
  }

  return (
    <>
      {/* Next 1-on-1 + goals preview */}
      <div className="flex items-center gap-4">
        {organization.featureFlags.goals && (
          <Button
            theme={buttonTheme.lightGray}
            to={`/goals/user/${profile.id}`}
          >
            <TbTarget className="w-4 h-4" />
            {label("goal", { pluralize: true, titleCase: true })}:
            <span className="flex gap-1 items-center">
              {ownedGoals.length === 0 && "0"}
              {ownedGoals.slice(0, maxGoalsToShow).map((goal) => (
                <GoalStatusPill
                  key={goal.id}
                  status={goal.status}
                  state={goal.state}
                  isStale={goal.isStale}
                />
              ))}
              {ownedGoals.length > maxGoalsToShow && (
                <span className="text-gray-500 text-sm">
                  +{ownedGoals.length - maxGoalsToShow}
                </span>
              )}
            </span>
          </Button>
        )}
      </div>
    </>
  );
};

export default ProfileSidebarHeader;
